import React, { Component } from 'react';
import { connect } from 'react-redux';
import './success.css';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { getPayAccount,getLimitAmount, getTradeInfo } from '../action/productAction';
import { goHome } from '../common';
import Util from '../util.js';

class WebView extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount(){
    document.title = this.props.location.state.title
  }
  next(name){
    if (name==='返回我的智投'||name=='返回智投首页') {
      goHome()
    }else if(name==='返回华夏智投'){
      goHome()
    }else if(name==='查看银行卡'){
      // this.props.dispatch({
      //   type:"SUPER_FUND_PAY_INFO",
      //   text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
      // });
      // this.props.dispatch({
      //   type:"SUPER_FUND_DT_PAY_INFO",
      //   text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
      // });
      hashHistory.go(-4);
      setTimeout(() => {
        this.props.dispatch(getTradeInfo(this.props.location.state.fundCode,'T522',this.props.location.state.productType,(result,i,type)=>{
          Object.assign(result,{currentType:type},{currentIndex:i})
          this.props.dispatch({
            type:"SUPER_FUND_PAY_INFO",
            text:result
          });
        }))
      });
    }else if(name==='查看定投计划'){
      hashHistory.push({
        pathname: '/InvestmentPlan',
      });
    }else if(name==='返回我的资产'){
      goHome()
    }else if(name==='查看我的投资'){
      goHome()
    }else if(name==='返回产品首页'){
      goHome()
    }else if(name=='查看交易详情'){
      hashHistory.push({
        pathname: '/TransactionDetail',
        state:{
          data:{tradeRequestId:this.props.location.state.dataSouse[0][1]},
          flag:'JL'
        }
      });
    }else if(name=='完成'){
      hashHistory.replace({
         pathname:`/SubscriptionDetail?enterType=SubscriptionDetail` ,
      })
    }else if(name=='返回'){
      hashHistory.go(-1)
      this.props.dispatch({
        type:"SUPER_FUND_PAY_INFO",
        text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
      });
      this.props.dispatch({
        type:"SUPER_FUND_DT_PAY_INFO",
        text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
      });
    }
  }
  goDetail(name) {
    if (name==='返回我的智投'||name=='返回智投首页'||name==='返回华夏智投'||name==='查看我的智投') {
      goHome()
      return;
    }
    let SupperFundHome = this.props.SupperFundHome;
    let {fundCode} = this.props.location.state;
    console.log(SupperFundHome,fundCode)
    let pathName = "";
    if(this.props.location.state.superTypeValue === "1") {
      pathName = '/TargetProfitHaveCast'
    }else {
      pathName = '/SuperFundDetailHaveCast';
    }
    hashHistory.push({
          pathname: pathName,
          state: {
                superFundCode: fundCode
          },
          query: {
                superFundCode: fundCode
          }
    })
}
  render(){
    let {superFundConfirmAndIncomeDate,businessType} = this.props.location.state;
    return (
        <div className="container" >
          <NavigatorMain>
          <div className="header">
            <div></div>
            <div>{this.props.location.state.title}</div>
            <div></div>
          </div>
          </NavigatorMain>
          <div className='content' >
            <div className='success-box'>
              <img src={require('../imgs/success_new.png')} style={{width:'1.24rem',height:'1.24rem'}}/>
              <p style={{marginTop:'0.3rem',height:'0.9rem',color:'#333333',fontSize:'.36rem'}}>{this.props.location.state.content}</p>
              <div style={{width:'100%',marginTop:'.5rem'}}>
                {
                  this.props.location.state.dataSouse.map( (item,i)=> {
                    return(
                      <div key={'cq'+i} className='success-bar'>
                        <p >{item[0]}</p>
                        <p style={{color:this.props.location.state.dataSouse.length - 1 == i?"#B69271" :"#333333"}}>{item[1]}</p>
                      </div>
                    )
                  })
                }
              </div>
            </div>
           {

            businessType && (businessType =='T522' || businessType =='T422' || businessType =='T822') ?
            <div className='success—step'>
              <div style={{display:'flex',flexDirection:'row',height:'.6rem',alignItems:'center'}}>
                <div className='step-circle-ed'></div>
                <p style={{color:'#333333',fontSize:'.28rem',lineHeight:'.4rem'}}>申请已受理</p>
              </div>
              <div style={{width:'1px',height:'.8rem',backgroundColor:'#BF9B79',marginLeft:'4.5px',marginTop:'-.2rem'}}></div>
              <div style={{display:'flex',flexDirection:'row',height:'.6rem',alignItems:'center',marginTop:'-.2rem'}}>
                <div className='step-circle-ing'></div>
                <p style={{color:'#333333',fontSize:'.28rem',lineHeight:'.4rem'}}>{superFundConfirmAndIncomeDate.buyConfirmDate && superFundConfirmAndIncomeDate.buyConfirmWeek?`预计${superFundConfirmAndIncomeDate.buyConfirmDate} ${superFundConfirmAndIncomeDate.buyConfirmWeek} 15:00前确认份额`:`预计 -- 前确认份额`}</p>
              </div>
              <div style={{width:'1px',height:'.8rem',backgroundColor:'#D9D9D9',marginLeft:'4.5px',marginTop:'-.2rem'}}></div>
              <div style={{display:'flex',flexDirection:'row',height:'.6rem',alignItems:'center',marginTop:'-.2rem'}}>
                <div className='step-circle-ing'></div>
                <p style={{color:'#333333',fontSize:'.28rem',lineHeight:'.4rem'}}>{superFundConfirmAndIncomeDate.buyIncomeDate && superFundConfirmAndIncomeDate.buyIncomeWeek?`预计${superFundConfirmAndIncomeDate.buyIncomeDate} ${superFundConfirmAndIncomeDate.buyIncomeWeek} 开始查看收益`:`预计 -- 开始查看收益`}</p>
              </div>
            </div>
            :null

            }

            {
              this.props.location.state.souseVal.map( (item,i) =>{
                if (i==0) {
                  return(
                    <div key={'bt'+i} onClick={()=>this.goDetail(item)}  className='btn-yellow'>
                      {item}
                    </div>
                  )
                }else{
                  return(
                    <div key={'bt'+i} onClick={()=>this.next(item)}  className='btn btn-white'>
                      {item}
                    </div>
                  )
                }
              })
            }
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome,
  }
}
export default connect(mapStateToProps)(WebView);



// WEBPACK FOOTER //
// ./src/components/Success.js